import request from '@/router/axios'

const pre_fix = "/dotadmin/dotadmin/order/"

export function pageOrder(query) {
  return request({
    url: pre_fix + 'page',
    method: 'get',
    params: query
  })
}


export function oriFile(id) {
  return request({
    url: pre_fix + 'ori_file/' + id,
    method: 'get'
  })
}

export function cost(id) {
  return request({
    url: pre_fix + 'cost/' + id,
    method: 'get'
  })
}


export function getObj(id) {
  return request({
    url: pre_fix + id,
    method: 'get'
  })
}

export function countWords(id) {
  return request({
    url: pre_fix + 'countWords/' + id,
    method: 'get'
  })
}

export function submit(id) {
  return request({
    url: pre_fix + id,
    method: 'post',
  })
}

export function configList(flowInfo) {
  return request({
    url: pre_fix + 'configList',
    method: 'get',
    params: flowInfo
  })
}

export function rePush(id, taskType) {
  return request({
    url: pre_fix + "rePush/" + id,
    method: 'post',
    params: {taskType: taskType}
  })
}

export function remind(id, taskType) {
  return request({
    url: pre_fix + "remind/" + id,
    method: 'post',
    params: {taskType: taskType}
  })
}


export function rePushSingle(info) {
  return request({
    url: pre_fix + "rePushSingle",
    method: 'post',
    params: info
  })
}

export function termPassPage(obj) {
  return request({
    url: pre_fix + "termPassPage",
    method: 'post',
    params: obj
  })
}


export function recommend(orderId, type, limitTime) {
  return request({
    url: pre_fix + 'recommend/' + orderId,
    method: 'get',
    params: {type: type, limitTime: limitTime}
  })
}

export function gerRedisPushRemind(orderId, flowType) {
  return request({
    url: pre_fix + 'gerRedisPushRemind/' + orderId + "/" + flowType,
    method: 'get',
  })
}

export function qcTaskSentencePage(param) {
  return request({
    url: pre_fix + 'qcTaskSentencePage',
    method: 'get',
    params: param
  })
}


export function pushDetailTj(orderId, taskType) {
  return request({
    url: pre_fix + 'pushDetailTj/' + orderId + "/" + taskType,
    method: 'get',
  })
}


export function pushDetailTr(param) {
  return request({
    url: pre_fix + 'pushDetailTr',
    method: 'get',
    params: param
  })
}

export function pushStatusByOrderId(orderId) {
  return request({
    url: pre_fix + 'pushStatusByOrderId/' + orderId,
    method: 'get',
  })
}

export function rePushAll(orderId, taskType) {
  return request({
    url: pre_fix + "rePushAll/" + orderId,
    method: 'post',
    params: {taskType: taskType}
  })
}

export function tjInfo(orderId) {
  return request({
    url: '/dotadmin/dotadmin/mt/tj/' + orderId,
    method: 'get'
  })
}